import script from "./googlePlay.vue?vue&type=script&setup=true&lang=js"
export * from "./googlePlay.vue?vue&type=script&setup=true&lang=js"

import "./googlePlay.vue?vue&type=style&index=0&id=24109104&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24109104"]])

export default __exports__